import { InjectionToken } from '@angular/core';
export const APPLICATION_API_OPTIONS = new InjectionToken('ApplicationApiOptions');
/**
 * List of app names that SHOULD automatically load user roles.
 * Only app names in this list will have user role loading enabled.
 *
 * Example: ['Sandbox', 'ragnarok', 'linear-console-api-dev-ui']
 */
const APPS_WITH_USER_ROLE_LOADING = [
    // Add app names here that should load user roles
    'C3 Linear Monitoring',
    // 'Media Ingest Console', // Removed - using Admin Console permissions now
    'Pitch New Syndication'
];
export class ApplicationApiConstants {
    /**
     * Determines if user roles should be loaded for the current app.
     * Returns true only if the app name is in the APPS_WITH_USER_ROLE_LOADING list.
     */
    static shouldLoadUserRoles() {
        if (!this.activeAppName) {
            return false; // Default to false if app name not set
        }
        console.log('🚀---- activeAppName appConfig ----', this.activeAppName);
        console.log('🚀---- APPS_WITH_USER_ROLE_LOADING ----', APPS_WITH_USER_ROLE_LOADING.includes(this.activeAppName));
        return APPS_WITH_USER_ROLE_LOADING.includes(this.activeAppName);
    }
}
//# sourceMappingURL=application-api-config.js.map